import { TriageVerdict } from 'core/graphql';

export const TRIAGE_VERDICT_LABELS: { [key in TriageVerdict]: string } = {
  [TriageVerdict.Malicious]: 'Malicious',
  [TriageVerdict.Suspicious]: 'Suspicious',
  [TriageVerdict.Benign]: 'Benign',
  [TriageVerdict.Inconclusive]: 'Inconclusive',
  [TriageVerdict.InProgress]: 'In Progress',
};
